import type {
  ApiV1SurveyExportSettingsGeneralPatchRequest,
  SurveyExportSettingsApi,
} from "../generated";
import { createAPISlice } from "./createAPISlice";
import type { MediaFile } from "../apiTypes";

export default function createNotificationApis(
  surveyExportSettingsApi: SurveyExportSettingsApi,
) {
  return createAPISlice({
    /* Logo */
    getLogo: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsLogoGet();
    },
    postLogo: async ({ logo }: { logo: MediaFile }) => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsLogoPost(
        // @ts-expect-error swagger generated code doesn't support File type, but it does work with it
        logo,
      );
    },
    deleteLogo: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsLogoDelete();
    },
    /* Signatures */
    getSignature: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsSignatureGet();
    },
    postSignature: async ({ signature }: { signature: MediaFile }) => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsSignaturePost(
        // @ts-expect-error swagger generated code doesn't support File type, but it does work with it
        signature,
        "signature",
      );
    },
    deleteSignature: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsSignatureDelete();
    },
    /* Stamps */
    getStamps: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsStampGet();
    },
    postStamp: async ({ stamp }: { stamp: MediaFile }) => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsStampPost(
        // @ts-expect-error swagger generated code doesn't support File type, but it does work with it
        stamp,
        "stamp",
      );
    },
    deleteStamp: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsStampDelete();
    },
    /* Technical attachments */
    getTechnicalAttachments: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsGet();
    },
    postTechnicalAttachment: async ({
      technicalAttachment,
      title,
    }: {
      technicalAttachment: MediaFile;
      title: string;
    }) => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsPost(
        // @ts-expect-error swagger generated code doesn't support File type, but it does work with it
        technicalAttachment,
        title,
      );
    },
    patchTechnicalAttachment: async ({
      technicalAttachmentApiId,
      data,
    }: {
      technicalAttachmentApiId: string;
      data: { title: string; active?: boolean };
    }) => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch(
        technicalAttachmentApiId,
        data,
      );
    },
    deleteTechnicalAttachment: async (technicalAttachmentApiIdd: string) => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete(
        technicalAttachmentApiIdd,
      );
    },
    /* General settings */
    getGeneralSettings: async () => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsGeneralGet();
    },
    patchGeneralSettings: async (
      data: ApiV1SurveyExportSettingsGeneralPatchRequest,
    ) => {
      return await surveyExportSettingsApi.apiV1SurveyExportSettingsGeneralPatch(
        data,
      );
    },
  });
}
